import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/kestrel')({
  component: RouteComponent,
  staticData: {
    title: 'Kestrel',
  },
})

function RouteComponent() {
  return <Outlet />
}
